import script from "./TasksView.vue?vue&type=script&setup=true&lang=js"
export * from "./TasksView.vue?vue&type=script&setup=true&lang=js"

import "./TasksView.vue?vue&type=style&index=0&id=7112110f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7112110f"]])

export default __exports__